import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccProductReviewsAdapter, PRODUCT_REVIEW_SERIALIZER, Review } from '@spartacus/core';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class OccGgProductReviewsAdapter extends OccProductReviewsAdapter {
  override post(productCode: string, review: any): Observable<Review> {
    review = this.converter.convert(review, PRODUCT_REVIEW_SERIALIZER);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    });

    const body = new URLSearchParams();
    body.append('headline', review.headline);
    body.append('comment', review.comment);
    body.append('rating', review.rating.toString());
    body.append('alias', review.alias);
    body.append('awardGame', review.awardGame);
    body.append('reviewAsGuest', review.reviewAsGuest);
    body.append('guestEmail', review.guestEmail);

    return this.http.post(this.getEndpoint(productCode), body.toString(), {
      headers,
    });
  }
}
